import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import Order from './../paymentMethod/PaymentMethod';
import DialogBase from './DialogBase';
import { DialogContent } from '@mui/material';

class DialogPaymentMethod extends React.Component {

  render () {
    const { classes, open, onClose, ...others } = this.props;
    const scrollableTargetId = "dialog-payment-method";
    return (
      <DialogBase
        maxWidth="xs"
        open={open}
        onClose={onClose}
      >
        <DialogContent classes={{root: classes.dialogContent}} id={scrollableTargetId}>
          <Order
            scrollableTarget={scrollableTargetId}
            {...others}
          />
        </DialogContent>
      </DialogBase>
    )
  }
}

const styles = theme => ({
  dialogContent: {
  },
});

DialogPaymentMethod.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(DialogPaymentMethod);
